/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These exports are for client side use only
# Importing into post office backend without a bundler will break the build
#
# Generate source: local/cli/src/commands/generate-all/team-export.ts
*/
import { lazy } from "react";

export default {
	'jira-forms-conditional-fields-changeboarding': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-forms-conditional-fields-changeboarding/placements/in-app/screen-space-flags/render'
			),
	),
	'jira-forms-public-forms-changeboarding': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-forms-public-forms-changeboarding/placements/in-app/screen-space-flags/render'
			),
	),
	'jira-forms-public-forms-changeboarding-flag': lazy(
			() =>
			import(
				/* webpackChunkName: "[request]" */
				'@post-office/message-template--jira-forms-public-forms-changeboarding-flag/placements/in-app/screen-space-flags/render'
			),
	),
};
